import { viewports } from '@telus-uds/system-constants';
const inherit = _ref => {
  let {
    xs,
    sm = xs,
    md = sm,
    lg = md,
    xl = lg
  } = _ref;
  return {
    xs,
    sm,
    md,
    lg,
    xl
  };
};

/**
 * @typedef { Object } CssStyles
 */

/**
 * @typedef { Object } ViewportStyles
 * @property { CssStyles } xs - The CSS styles for the "xs" viewport (required).
 * @property { CssStyles } [sm] - Optional styles for the "sm" viewport. Inherits from "xs" if not specified.
 * @property { CssStyles } [md] - Optional styles for the "md" viewport. Inherits from "sm" if not specified.
 * @property { CssStyles } [lg] - Optional styles for the "lg" viewport. Inherits from "md" if not specified.
 * @property { CssStyles } [xl] - Optional styles for the "xl" viewport. Inherits from "lg" if not specified.
 */

/**
 * @typedef { Record<String, CssStyles> } MediaQueryStyles
 */

/**
 * Generates media query styles based on specified viewport styles.
 * @param { Object } viewportStyles - The styles for different viewports.
 * @param { boolean } [shouldInherit=true] - Flag indicating whether to inherit styles.
 * @returns { Object } - The media query styles.
 */

function createMediaQueryStyles(viewportStyles) {
  let shouldInherit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const effectiveStyles = shouldInherit ? inherit(viewportStyles) : viewportStyles;
  const viewportsArray = viewports.keys;
  const mediaQueries = Object.entries(effectiveStyles).reduce((acc, _ref2) => {
    let [viewport, styles] = _ref2;
    const minWidth = viewports.map.get(viewport);
    const nextViewport = viewportsArray[viewportsArray.indexOf(viewport) + 1];
    const maxWidth = viewports.map.get(nextViewport);
    const mediaQuery = `@media (min-width: ${minWidth}px)${maxWidth ? ` and (max-width: ${maxWidth}px)` : ''}`;
    return {
      ...acc,
      [mediaQuery]: styles
    };
  }, {});
  return mediaQueries;
}
export default createMediaQueryStyles;